import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import { BookingDetailReducer, BookingUpdateReducer } from "../slice";

function BookingDetail() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [modalName, setModalName] = useState("");
  const [inpectionItem, setInpectionItem] = useState();
  // console.log(inpectionItem);
  const handleShow = () => {
    setShow(!show);
  };

  const detail = useSelector((store) => store.main.BookingDetail);

  const getdetail = useCallback(() => {
    setLoading(true);
    dispatch(
      BookingDetailReducer({
        bookingId: id,
      })
    ).then((res) => {
      if (res?.payload?.code === 1) {
        setInpectionItem(
          res?.payload?.data?.otherInspectionDetails?.map((item) => {
            return {
              name: item?.name,
              status: item?.status === 1 ? true : false,
              iconUrl: item?.iconUrl,
            };
          })
        );
        setLoading(false);
      }
    });
  }, [dispatch, id]);

  useEffect(() => {
    getdetail();
  }, [getdetail]);

  const updateBooking = () => {
    setLoading(true);
    dispatch(
      BookingUpdateReducer({
        bookingId: id,
        otherInspectionDetails: inpectionItem?.map((item) => {
          return {
            name: item?.name,
            status: item?.status === true ? 1 : 0,
            iconUrl: item?.iconUrl,
          };
        }),
      })
    ).then((res) => {
      if (res?.payload?.code === 1) {
        toast.success(res?.payload?.message);
        getdetail();
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12 mb-3 text-center">
            <h3>My Booking</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetueradipiscing elit. Aenean
              commodo ligula eget dolor. Aenean massa.
            </p>
          </div>
        </div>

        {loading ? (
          <Loader colorChange="colorChange" />
        ) : (
          <>
            <div className="col-sm-12 col-md-12 col-lg-12 mb-4">
              <span className="dateBoxColor">
                <span className="dateFont">
                  {moment(detail?.dateOfInspection).format("DD")}
                </span>{" "}
                {moment(detail?.dateOfInspection).format("MMMM, YYYY")}
              </span>
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div className="d-flex align-items-center gap-2 bg-white p-3 h-100">
                  <img
                    src="assets/images/FastDelivery.png"
                    alt=""
                    className="detailIcon"
                  />{" "}
                  <span>
                    Order ID-<b>{detail?.bookingId}</b>
                  </span>{" "}
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div className="d-flex align-items-center gap-2 bg-white p-3 h-100">
                  <img
                    src="assets/images/detaillocation.png"
                    alt=""
                    className="detailIcon"
                  />{" "}
                  <div>
                    <p className="mb-0 bookingTitle">
                      {detail?.propertyId?.propertyName
                        ? detail?.propertyId?.propertyName
                        : detail?.propertyName}
                    </p>
                    <p className="mb-0 position-relative addresArea">
                      {detail?.location}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div className="d-flex align-items-center gap-2 bg-white p-3 h-100">
                  <img
                    src="assets/images/select_area_icon.png"
                    alt=""
                    className="detailIcon"
                  />{" "}
                  <div>
                    <p className="mb-0">Area: {detail?.area}</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div className="d-flex align-items-center gap-2 bg-white p-3 h-100">
                  <img
                    src="assets/images/price-list.png"
                    alt=""
                    className="detailIcon"
                  />{" "}
                  <div>
                    <p className="mb-0 text-capitalize">
                      Plan: <b>{detail?.packageId?.packageName}</b>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div className="d-flex align-items-center gap-2 bg-white p-3 h-100">
                  <img
                    src="assets/images/status.png"
                    alt=""
                    className="detailIcon"
                  />{" "}
                  <div>
                    <p className="mb-0 text-capitalize">
                      status:{" "}
                      <span
                        className={
                          detail?.orderStatus === ""
                            ? "StatusBtn canceledStatus"
                            : detail?.orderStatus === 1
                            ? "StatusBtn pendingStatus"
                            : detail?.orderStatus === 2
                            ? "StatusBtn approvedStatus"
                            : detail?.orderStatus === -1
                            ? "StatusBtn rejectedStatus"
                            : null
                        }
                      >
                        {detail?.orderStatus === ""
                          ? "New"
                          : detail?.orderStatus === 1
                          ? "Ongoing"
                          : detail?.orderStatus === 2
                          ? "completed"
                          : detail?.orderStatus === -1
                          ? "cancelled"
                          : null}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6 mb-4">
                <div className="bg-white p-3 h-100">
                  <div className="nav nav-pills justify-content-start checkboxs">
                    {inpectionItem?.map((item, i) => (
                      <div className="nav-item m-0" key={i}>
                        <input
                          id={item?.name}
                          name={`inpectionItem.[${i}].status`}
                          type="checkbox"
                          //   value={item?.status === 1 ? true : false}
                          onChange={(e) => {
                            let checked = e.target.checked;
                            let arr = [...inpectionItem];
                            let arr2 = arr.map((it, ind) => {
                              if (ind === i) {
                                return {
                                  ...it,
                                  status: checked,
                                };
                              }
                              return it;
                            });

                            setInpectionItem(arr2);
                          }}
                          checked={item?.status}
                        />
                        <label htmlFor={item?.name}>
                          {item?.iconUrl && (
                            <img
                              src={item?.iconUrl}
                              alt=""
                              className="iconsSize"
                            />
                          )}{" "}
                          {item?.name}
                        </label>
                      </div>
                    ))}
                  </div>
                  {/* <div>
                    <p className="mb-0 text-capitalize">
                      {detail?.inpectionItem?.map((item, i) => (
                        <>
                          {" "}
                          <div
                            key={i}
                            className={
                              item?.status === 1
                                ? "activeItem"
                                : "activeItem Not"
                            }
                          >
                            {item?.name}
                          </div>{" "}
                        </>
                      ))}
                    </p>
                  </div> */}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12 mb-4">
                <div className="text-center">
                  <span
                    className="btn btn-save fs-6 w-auto px-3"
                    onClick={() => {
                      updateBooking();
                    }}
                  >
                    {loading ? <Loader /> : "Update"}
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default BookingDetail;
